import { Roles } from "./enums";

export class UserModel {
  public id: string;
  public firstName: string;
  public lastName: string;
  public email: string;
  public photo: any;
  public companyName: string;
  public companyId: string;
  public role: Roles;
  public isCompanyEnabledForNonLiveInUK: boolean;
  public thumbnail?: any;
  constructor() {}
}

export interface IUserRole {
  id: string;
  name: string;
  description: string;
  level: number;
}
